import './ArtistPage.scss';
import ArtistPageContent from "./ArtistPageContent";
import ArtistPageContext from './ArtistPageContext';
import ArtistPageLoader from "./ArtistPageLoader";
import usePageTitle from "../../hooks/PageTitle";

export default function ArtistPage() {

usePageTitle("Artist Page");

  return (
    <ArtistPageLoader>
      { ({ artist }) => (
        <ArtistPageContext artist={ artist }>
          <ArtistPageContent />
        </ArtistPageContext>
      ) }
    </ArtistPageLoader>
  );
}
